import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const LevelsGraphic = () => (
  <Container>
    <Row>
      <Col style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }}>
        <Row style={{
          backgroundColor: '#F3F5ED',
          padding: 20,
          marginTop: 48,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: 18,
          color: '#004761',
          fontFamily: 'Montserrat SemiBold',
          width: 180,
          marginRight: 20
        }}>
          INSURERS
        </Row>
        <Row style={{
          backgroundColor: '#F3F5ED',
          padding: 20,
          marginTop: 30,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: 18,
          color: '#004761',
          fontFamily: 'Montserrat SemiBold',
          width: 180,
          marginRight: 20
        }}>
          VENDORS
        </Row>
      </Col>
      <Col>
        <Row style={{
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: 18,
          color: '#004761',
          fontFamily: 'Montserrat SemiBold',
        }}>
          LEVEL I - FOUNDATION
        </Row>
        <Row style={{
          color: '#4D788D',
          fontFamily: 'Montserrat SemiBold',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          fontSize: 16,
          padding: 20,
          minHeight: 114,
          borderBottom: '1px solid #E4E8E0'
        }}>
          Northbridge Insurance Travelers Canada<br/>Unica Insurance
        </Row>
        <Row style={{
          color: '#4D788D',
          fontFamily: 'Montserrat SemiBold',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 16,
          padding: 20,
          minHeight: 114
        }}>
          Applied Systems Inc.<br/>Brokercore<br />Vertafore Canada
        </Row>
      </Col>
      <Col>
        <Row style={{
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: 18,
          color: '#004761',
          fontFamily: 'Montserrat SemiBold',
        }}>
          LEVEL II - VERIFIED
        </Row>
        <Row style={{
          color: '#4D788D',
          fontFamily: 'Montserrat SemiBold',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          fontSize: 16,
          padding: 20,
          minHeight: 114,
          borderBottom: '1px solid #E4E8E0',
          borderLeft: '1px solid #E4E8E0'
        }}>
          Northbridge Insurance
        </Row>
        <Row style={{
          color: '#4D788D',
          fontFamily: 'Montserrat SemiBold',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          fontSize: 16,
          padding: 20,
          minHeight: 114,
          borderLeft: '1px solid #E4E8E0'
        }}>
          Applied Systems Inc. Brokercore
        </Row>
      </Col>
    </Row>
  </Container>
)

export default LevelsGraphic;
